import {ValueObject} from '@s-ui/domain'

export default class ContactResponseV2ValueObject extends ValueObject {
  #config
  #token
  #userId
  #status
  #messageContactId
  #error

  constructor({config, token, userId, status, messageContactId, error}) {
    super()
    this.#config = config
    this.#token = token
    this.#userId = userId
    this.#status = status
    this.#messageContactId = messageContactId
    this.#error = error
  }

  static create({response: apiResponse, config}) {
    const {data: {token, userId, messageContactId} = {}, status} = apiResponse
    return new ContactResponseV2ValueObject({
      config,
      token,
      userId,
      status,
      messageContactId,
      error: {message: apiResponse.message, error: apiResponse.response?.data, status}
    })
  }

  getResponseStatusLiteral() {
    return (
      this.#config.get('USER_CONTACT_BY_MAIL_RESPONSES')[this.#status] ||
      this.#config.get('DEFAULT_USER_CONTACT_BY_MAIL_RESPONSE')
    )
  }

  toJSON() {
    return {
      contactToken: this.#token,
      userId: this.#userId,
      messageContactId: this.#messageContactId,
      error: this.#error,
      ...this.getResponseStatusLiteral()
    }
  }
}
